import React from "react";
import { motion } from "framer-motion";
import HeroImage from "./HeroImage";

const HeroSection = ({ 
  title, 
  subtitle, 
  image,
  description,
  imageMaxWidth = "max-w-[5000px]",
  textWidth = "md:w-1/1",
  imageClassName = "",
  isHomePage = false,
  hideImage = false,
  isDataSheet,
  dataSheetLink
}) => {
  return (
    <div className={`relative w-full ${isHomePage ? 'h-[600px]' : 'h-[500px]'} bg-gradient-background overflow-hidden`}>
      {/* Background gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-primary/10 via-secondary/10 to-accent/10" />
      
      {/* Main content */}
      <div className="relative z-20 h-full flex items-center">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            className={`relative ${hideImage ? 'max-w-full text-center' : 'max-w-[45%] text-left'}`}
          >
            <div className={`flex flex-col space-y-6 ${hideImage ? 'items-center' : 'items-start'}`}>
              <h1 className="text-4xl md:text-6xl font-bold bg-clip-text text-transparent bg-gradient-primary leading-tight">
                {title}
              </h1>
              <h6 className={`text-2xl text-white ${hideImage ? 'max-w-2xl mx-auto' : 'max-w-[90%]'} leading-relaxed`}>
                {subtitle}
              </h6>
              <p className={`text-lg text-white ${hideImage ? 'max-w-l mx-auto' : 'max-w-[90%]'} leading-relaxed`}>
                {description}
              </p>
              {isDataSheet && (
                <button
                  onClick={() =>
                    window.open(dataSheetLink, '_blank')
                  }
                  className="bg-gradient-primary hover:bg-gradient-secondary text-white px-8 py-4 rounded-lg font-semibold transition-all transform hover:scale-105 shadow-glow"
                >
                  Datasheet
                </button>
              )}
            </div>
          </motion.div>
        </div>

        {image && !hideImage && (
          <div className="absolute right-[5%] top-1/2 transform -translate-y-1/2">
            <img 
              src={image}
              alt={title}
              className={`${imageClassName} w-[400px] md:w-[600px] lg:w-[800px] h-auto`}
            />
          </div>
        )}
      </div>
      
      {/* Decorative elements */}
      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-background-dark to-transparent" />
      <div className="absolute top-0 left-0 w-full h-32 bg-gradient-to-b from-background-dark to-transparent" />
    </div>
  );
};

export default HeroSection;